import React from 'react';
import Tag from 'shared/components/atoms/Tag';
import { Box } from 'shared/components/display';
import { ChatFilterState } from 'shared/messaging/types';
import { AccountManager } from 'shared/typings/account';
import styles from './styles';

interface Props {
  filterState: ChatFilterState; // from stream chat state
  removeAccountManager: (accountManager: AccountManager) => void;
  removeBrand: (accountId: number) => void;
}
const ActiveChannelFilters: React.FC<Props> = ({
  filterState: { selectedAccountManager, selectedBrands },
  removeAccountManager,
  removeBrand,
}) => {
  return (
    <Box css={styles} className="active-channel-filters">
      {selectedAccountManager && (
        <Tag
          onDelete={() => selectedAccountManager && removeAccountManager(selectedAccountManager)}
          className="active-channel-filters__tag"
          key={selectedAccountManager?.name}
        >
          {selectedAccountManager?.name}
        </Tag>
      )}
      {selectedBrands.map((brand) => (
        <Tag onDelete={() => removeBrand(brand.id)} className="active-channel-filters__tag" key={brand.name}>
          {brand.name}
        </Tag>
      ))}
    </Box>
  );
};

export default ActiveChannelFilters;
